import { Box, Container, Grid } from "@mui/material";
import TransmissionDetailsList from "../components/TransmissionDetailsList";

const TransactionLogs = () => {
  return (
    <Box component="main">
      <Container maxWidth="xl">
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} lg={12}>
            <TransmissionDetailsList />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TransactionLogs;
